"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlayOsmoAPIUrl = exports.AASHISH_URL = exports.CLEMENT_URL = exports.ERWAN_URL = exports.SURBHI_URL = exports.TOMMY_URL = exports.BINIT_URL = exports.LATHA_URL = exports.MARION_URL = exports.ABHIJIT_URL = exports.PROD_URL = exports.DEVELOP_URL = exports.BETA_URL = exports.HOTFIX_URL = exports.RELC_URL = void 0;
var environments_1 = require("../../config/environments");
exports.RELC_URL = 'https://relc.dev.playosmo.com';
exports.HOTFIX_URL = 'https://hotfix.dev.playosmo.com';
exports.BETA_URL = 'https://beta.dev.playosmo.com';
exports.DEVELOP_URL = 'https://develop.dev.playosmo.com';
exports.PROD_URL = 'https://www.playosmo.com';
exports.ABHIJIT_URL = 'https://abhijit.dev.playosmo.com';
exports.MARION_URL = 'https://marion.dev.playosmo.com';
exports.LATHA_URL = 'https://latha.dev.playosmo.com';
exports.BINIT_URL = 'https://binit.dev.playosmo.com';
exports.TOMMY_URL = 'https://tommy.dev.playosmo.com';
exports.SURBHI_URL = 'https://surbhi.dev.playosmo.com';
exports.ERWAN_URL = 'https://erwan.dev.playosmo.com';
exports.CLEMENT_URL = 'https://clement.dev.playosmo.com';
exports.AASHISH_URL = 'https://aashish.dev.playosmo.com';
var getPlayOsmoAPIUrl = function (environment) {
    switch (environment) {
        case environments_1.ENV_RELC:
            return exports.RELC_URL;
        case environments_1.ENV_BETA:
            return exports.BETA_URL;
        case environments_1.ENV_DEVELOP:
            return exports.DEVELOP_URL;
        case environments_1.ENV_HOTFIX:
            return exports.HOTFIX_URL;
        case environments_1.ENV_ABHIJIT:
            return exports.ABHIJIT_URL;
        case environments_1.ENV_MARION:
            return exports.MARION_URL;
        case environments_1.ENV_LATHA:
            return exports.LATHA_URL;
        case environments_1.ENV_BINIT:
            return exports.BINIT_URL;
        case environments_1.ENV_TOMMY:
            return exports.TOMMY_URL;
        case environments_1.ENV_SURBHI:
            return exports.SURBHI_URL;
        case environments_1.ENV_ERWAN:
            return exports.ERWAN_URL;
        case environments_1.ENV_CLEMENT:
            return exports.CLEMENT_URL;
        case environments_1.ENV_AASHISH:
            return exports.AASHISH_URL;
        case environments_1.ENV_PRODUCTION:
            return exports.PROD_URL;
        case environments_1.ENV_LOCAL_WITH_BE:
            return window.location.origin;
        default:
            break;
    }
};
exports.getPlayOsmoAPIUrl = getPlayOsmoAPIUrl;
